import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TypeTriageService {

  private selectedIndexSubject: BehaviorSubject<number> = new BehaviorSubject<number>(-1);

  constructor() { }

  setSelectedIndex(index: number): void {
    this.selectedIndexSubject.next(index);
  }

  getSelectedIndex(): Observable<number> {
    console.log("Índice seleccionado(Mensaje desde el Traige):", this.selectedIndexSubject);
    return this.selectedIndexSubject.asObservable();
  }
}
